import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './components/login/authConfig';
import { MsalProvider } from '@azure/msal-react';
import { SelectedAlertsProvider } from "utils/SelectedAlertContext";
import './colors.css'; // Import global CSS
import { PersonaProvider } from "utils/personaContext";
import { SamarthDashboardProvider } from "utils/samarth-dashboard-context/samarth-dashboard-context";

const msalInstance = new PublicClientApplication(msalConfig);

const initPromise = msalInstance.initialize();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <MsalProvider instance={msalInstance}>
        <SelectedAlertsProvider>
            <PersonaProvider>
                <SamarthDashboardProvider>
                  <App />
                </SamarthDashboardProvider>
            </PersonaProvider>
        </SelectedAlertsProvider>
    </MsalProvider>
);

export { msalInstance, initPromise };
